(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["juvorra-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('juvorra-hero-video')) {
    customElements.define('juvorra-hero-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        const sync = () => {
          const label = video.paused ? button.dataset.play : button.dataset.pause;
          button.textContent = label;
          button.setAttribute('aria-label', label);
        };
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        button.addEventListener('click', () => {
          if (video.paused) video.play().catch(sync);
          else video.pause();
        });
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(sync);
        sync();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juvorra-motion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('juvorra-motion')) {
  customElements.define('juvorra-motion',class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.viewport=this.querySelector('.juvorra-motion__viewport');
      this.track=this.querySelector('.juvorra-motion__track');
      this.manualPause=matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.active=null; this.hovered=false; this.focused=false; this.touch=false; this.dragging=false; this.visible=false; this.fraction=0;
      const movement=this.querySelector('.juvorra-motion__movement');
      const syncMovement=()=>{movement.textContent=this.manualPause?movement.dataset.resume:movement.dataset.pause;movement.setAttribute('aria-pressed',String(this.manualPause));};
      syncMovement();
      movement.addEventListener('click',()=>{this.manualPause=!this.manualPause;syncMovement();},options);
      this.addEventListener('pointerover',event=>{
        if(event.pointerType!=='mouse')return;
        const card=event.target.closest('.juvorra-motion__card');
        if(card&&!card.contains(event.relatedTarget)){this.touch=false;this.hovered=true;this.playCard(card);}
      },options);
      this.addEventListener('pointerout',event=>{
        if(event.pointerType!=='mouse')return;
        const card=event.target.closest('.juvorra-motion__card');
        if(card&&!card.contains(event.relatedTarget)){this.hovered=false;if(!this.focused)this.stopCard();}
      },options);
      this.addEventListener('focusin',event=>{if(event.target.closest('.juvorra-motion__card'))this.focused=true;},options);
      this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=!!document.activeElement?.closest('juvorra-motion .juvorra-motion__card');if(!this.focused&&!this.hovered&&!this.touch)this.stopCard();});},options);
      this.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'){this.touch=true;this.dragging=true;}},options);
      document.addEventListener('pointerup',()=>{this.dragging=false;},options);
      document.addEventListener('pointercancel',()=>{this.dragging=false;},options);
      document.addEventListener('pointerdown',event=>{if(!this.contains(event.target)){this.touch=false;this.focused=false;this.stopCard();}},options);
      this.addEventListener('click',event=>{
        const card=event.target.closest('.juvorra-motion__card');
        if(!card)return;
        if(event.target.closest('.juvorra-motion__play')){
          if(!this.touch&&event.detail>0){if(this.active!==card)this.playCard(card);return;}
          if(this.active===card&&!card.querySelector('video').paused)this.stopCard();
          else this.playCard(card);
        }
        if(event.target.closest('.juvorra-motion__sound')){
          if(this.active!==card)this.playCard(card);
          const video=card.querySelector('video'); video.muted=!video.muted;
          const b=card.querySelector('.juvorra-motion__sound');
          b.setAttribute('aria-pressed',String(!video.muted));b.setAttribute('aria-label',video.muted?b.dataset.unmute:b.dataset.mute);
          if(!video.muted)document.querySelectorAll('audio').forEach(a=>a.pause());
        }
      },options);
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.stopCard();},options);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(!this.visible)this.stopCard();},{threshold:0.05});
      this.observer.observe(this);
      this.last=performance.now();
      const tick=now=>{
        const dt=Math.min(now-this.last,40);this.last=now;
        if(this.visible&&!document.hidden&&!this.manualPause&&!this.active&&!this.hovered&&!this.focused&&!this.dragging){
          this.fraction+=dt*0.018;
          const shift=Math.floor(this.fraction);this.fraction-=shift;
          if(shift)this.viewport.scrollLeft+=shift;
          const first=this.track.firstElementChild;
          const step=first.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);
          if(this.viewport.scrollLeft>=step){const left=this.viewport.scrollLeft-step;this.track.append(first);this.viewport.scrollLeft=left;}
        }
        this.frame=requestAnimationFrame(tick);
      };
      this.frame=requestAnimationFrame(tick);
    }
    playCard(card) {
      if(this.active===card)return;
      this.stopCard();
      document.querySelectorAll('video').forEach(v=>v.pause());
      this.active=card;
      const video=card.querySelector('video'),button=card.querySelector('.juvorra-motion__play');
      video.muted=true;
      video.play().then(()=>{if(this.active!==card){video.pause();return;}button.setAttribute('aria-pressed','true');button.setAttribute('aria-label',button.dataset.pause);}).catch(()=>{if(this.active===card)this.stopCard();});
    }
    stopCard() {
      if(!this.active)return;
      const card=this.active; this.active=null;
      const video=card.querySelector('video');video.pause();video.muted=true;
      const button=card.querySelector('.juvorra-motion__play');button.setAttribute('aria-pressed','false');button.setAttribute('aria-label',button.dataset.play);
      const sound=card.querySelector('.juvorra-motion__sound');sound.setAttribute('aria-pressed','false');sound.setAttribute('aria-label',sound.dataset.unmute);
    }
    disconnectedCallback(){this.stopCard();this.controller?.abort();this.controller=null;this.observer?.disconnect();cancelAnimationFrame(this.frame);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juvorra-store-tools"]) return;
  try {
    
if (!customElements.get('juvorra-music')) {
  customElements.define('juvorra-music', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const audio = this.querySelector('audio');
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      audio.volume = 0.25;
      const controller = new AbortController();
      this.dragController = controller;
      const options = { signal: controller.signal };
      let gesture = null, suppressClickUntil = 0, positioned = false;
      const place = (x, y) => {
        const rect = this.getBoundingClientRect();
        const left = Math.max(8, Math.min(x, innerWidth - rect.width - 8));
        const top = Math.max(8, Math.min(y, innerHeight - rect.height - 8));
        this.style.left = left + 'px'; this.style.top = top + 'px';
        this.style.right = 'auto'; this.style.bottom = 'auto';
        positioned = true;
      };
      const save = () => {
        const r = this.getBoundingClientRect();
        try { localStorage.setItem('juvorra-music-position', JSON.stringify({x:r.left/innerWidth,y:r.top/innerHeight})); } catch {}
      };
      try {
        const p = JSON.parse(localStorage.getItem('juvorra-music-position'));
        if(p && Number.isFinite(p.x) && Number.isFinite(p.y)) place(p.x*innerWidth,p.y*innerHeight);
      } catch {}
      button.addEventListener('pointerdown', e => {
        if(!e.isPrimary || e.button !== 0) return;
        const r=this.getBoundingClientRect();
        gesture={id:e.pointerId,x:e.clientX,y:e.clientY,left:r.left,top:r.top,moved:false};
        button.setPointerCapture(e.pointerId);
      }, options);
      button.addEventListener('pointermove', e => {
        if(!gesture || gesture.id!==e.pointerId) return;
        const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
        if(Math.hypot(dx,dy)>6) gesture.moved=true;
        if(gesture.moved){e.preventDefault();place(gesture.left+dx,gesture.top+dy);}
      }, options);
      const finish=e=>{
        if(!gesture || gesture.id!==e.pointerId)return;
        if(gesture.moved){suppressClickUntil=performance.now()+500;save();}
        gesture=null;
        if(button.hasPointerCapture(e.pointerId))button.releasePointerCapture(e.pointerId);
      };
      button.addEventListener('pointerup',finish,options);
      button.addEventListener('pointercancel',finish,options);
      button.addEventListener('keydown',e=>{
        if(!e.altKey || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key))return;
        e.preventDefault();const r=this.getBoundingClientRect();
        place(r.left+(e.key==='ArrowLeft'?-20:e.key==='ArrowRight'?20:0),r.top+(e.key==='ArrowUp'?-20:e.key==='ArrowDown'?20:0));save();
      },options);
      window.addEventListener('resize',()=>{
        if(positioned){const r=this.getBoundingClientRect();place(r.left,r.top);}
      },options);
      const credit=this.querySelector('details');
      credit?.addEventListener('toggle',()=>{
        if(!credit.open)return;
        const popup=credit.querySelector('div'),r=this.getBoundingClientRect();
        popup.style.position='fixed';popup.style.bottom='auto';popup.style.right='auto';
        popup.style.left=Math.max(8,Math.min(r.left,innerWidth-popup.offsetWidth-8))+'px';
        popup.style.top=Math.max(8,Math.min(r.top-popup.offsetHeight-8,innerHeight-popup.offsetHeight-8))+'px';
      },options);
      const sync = () => {
        button.setAttribute('aria-pressed', String(!audio.paused));
        button.setAttribute('aria-label', audio.paused ? button.dataset.play : button.dataset.pause);
      };
      audio.addEventListener('play', sync);
      audio.addEventListener('pause', sync);
      button.addEventListener('click', async () => {
        if(performance.now()<suppressClickUntil)return;
        status.textContent = '';
        if (!audio.paused) { audio.pause(); return; }
        try { await audio.play(); } catch { status.textContent = button.dataset.error; sync(); }
      });
    }
    disconnectedCallback() { this.querySelector('audio')?.pause(); this.dragController?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juvorra-tier-controller"]) return;
  try {
    
if(!customElements.get('juvorra-tier-controller')){
  customElements.define('juvorra-tier-progress',class extends HTMLElement{
    connectedCallback(){document.querySelector('juvorra-tier-controller')?.paintOne(this);}
  });
  customElements.define('juvorra-tier-buy',class extends HTMLElement{
    connectedCallback(){const c=document.querySelector('juvorra-tier-controller');const active=c && (!c.dataset.end || Date.now()<Date.parse(c.dataset.end));this.querySelector('[data-tier-native]').hidden=!!active;this.querySelector('[data-tier-buy]').hidden=!active;}
  });
  customElements.define('juvorra-tier-controller',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.busy=false;this.sequence=0;this.seen=new Set();
      this.controller=new AbortController();const opts={signal:this.controller.signal};
      this.dialog=this.querySelector('dialog');this.toast=this.querySelector('aside');
      document.addEventListener('cart:update',e=>{if(!e.detail?.data?.didError)this.refresh(e.detail?.data?.source==='product-form-component');},opts);
      document.addEventListener('discount:update',()=>this.refresh(),opts);
      window.addEventListener('pageshow',()=>this.refresh(),opts);
      document.addEventListener('click',e=>{
        const buy=e.target.closest('[data-tier-buy]');if(buy){e.preventDefault();this.buy(buy);}
        if(e.target.closest('[data-tier-close]'))this.dialog.close();
        if(e.target.closest('[data-tier-dismiss]'))this.toast.hidden=true;
      },opts);
      this.dialog.addEventListener('close',()=>this.opener?.focus(),opts);
      this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();},opts);
      this.expiryTimer=setInterval(()=>this.syncExpiry(),1000);this.syncExpiry();this.refresh();
    }
    disconnectedCallback(){this.controller?.abort();clearTimeout(this.toastTimer);clearInterval(this.expiryTimer);this.ready=false;}
    expired(){return !!this.dataset.end && Date.now()>=Date.parse(this.dataset.end);}
    syncExpiry(){
      if(!this.expired())return;
      document.querySelectorAll('.juvorra-tier-banner,juvorra-offer-countdown,juvorra-tier-progress').forEach(el=>el.hidden=true);
      document.querySelectorAll('juvorra-tier-buy').forEach(el=>{el.querySelector('[data-tier-native]').hidden=false;el.querySelector('[data-tier-buy]').hidden=true;});
      if(this.dialog.open)this.dialog.close();this.toast.hidden=true;
      clearInterval(this.expiryTimer);
    }
    message(count){return this.dataset[count>=3?'three':count===2?'two':count===1?'one':'zero'];}
    paintOne(el){if(this.expired()){el.hidden=true;return;}const count=this.cart?.item_count??Number(el.dataset.count??0);el.querySelector('[data-tier-message]').textContent=this.message(count);el.querySelectorAll('[data-tier-step]').forEach(s=>s.classList.toggle('is-unlocked',count>=Number(s.dataset.tierStep)));el.querySelector('[data-tier-shop]').hidden=count>=3;}
    paint(cart){this.cart=cart;document.querySelectorAll('juvorra-tier-progress').forEach(el=>this.paintOne(el));}
    async readCart(){const r=await fetch(this.dataset.root+'cart.js',{cache:'no-store'});if(!r.ok)throw Error(this.dataset.error);return r.json();}
    async refresh(notify=false){
      if(this.expired()){this.syncExpiry();return;}const seq=++this.sequence;try{const cart=await this.readCart();if(seq!==this.sequence||this.expired()){this.syncExpiry();return;}this.paint(cart);
        const stage=Math.min(cart.item_count,3);if(!notify||stage===0||this.dialog.open)return;
        const key='juvorra-tier-20260925-'+stage;let shown=this.seen.has(stage);try{shown=shown||sessionStorage.getItem(key)==='1';}catch{}
        if(shown)return;this.seen.add(stage);try{sessionStorage.setItem(key,'1');}catch{}
        if(document.querySelector('cart-drawer-component dialog[open]'))return;
        this.toast.querySelector('[data-tier-toast-message]').textContent=this.message(stage);this.toast.hidden=false;clearTimeout(this.toastTimer);this.toastTimer=setTimeout(()=>this.toast.hidden=true,10000);
      }catch{}}
    async buy(button){
      if(this.expired()){this.syncExpiry();return;}if(this.busy)return;const form=button.closest('form');if(!form||!form.reportValidity())return;
      const add=form.querySelector('[name="add"]');if(add?.disabled||add?.getAttribute('aria-disabled')==='true')return;
      const wrapper=button.closest('juvorra-tier-buy'),error=wrapper.querySelector('[data-tier-error]');
      this.busy=true;button.disabled=true;error.textContent='';let uncertain=false,accepted=false;
      try{
        const data=new FormData(form);data.delete('return_to');
        const sections=[...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean);
        if(sections.length)data.set('sections',[...new Set(sections)].slice(0,5).join(','));
        data.set('sections_url',location.pathname);
        let response;try{response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});}catch{uncertain=true;throw Error(this.dataset.uncertain);}
        if(response.status>=500){uncertain=true;throw Error(this.dataset.uncertain);}
        const result=await response.json();if(!response.ok||result.status)throw Error(result.description||this.dataset.error);accepted=true;
        const cart=await this.readCart();this.paint(cart);
        document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:'juvorra-tier-buy',data:{source:'juvorra-offer',sections:result.sections,itemCount:cart.item_count}}}));
        this.toast.hidden=true;this.opener=button;
        if(this.expired()||cart.item_count>=3){location.assign(this.dataset.root+'checkout');return;}
        this.dialog.showModal();
      }catch(e){uncertain=uncertain||accepted;error.textContent=uncertain?this.dataset.uncertain:(e.message||this.dataset.error);wrapper.querySelector('[data-tier-recover]').hidden=false;}
      finally{this.busy=false;button.disabled=uncertain;}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
